import * as _cr from "./_cr";
import * as _hm from "./_hm";
import * as _ht from "./_ht";

import { useMdlz } from "./_csMdl";
import { a } from "./_cmABT";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as TextC from "./_ccbTextC";

export const useCfmz = () => {

  const _sMdlz = useMdlz();

  const _show = (pz: {
    abtz?: {
      btnNextz?: _ht.dz,
    },
    text: _ht.s,
    ls?: _ht.ls,
    onPrs?: (_n: _ht.n) => void,
  }) => {
    const _dw = _cr.d('p') ? 'w3' : 'w2';
    const _ls = pz.ls ?? [
      { key: 1, text: 'はい' },
      { key:-1, text: 'いいえ' }
    ];
    _sMdlz.set({
      bShow: true,
      mdlClds: [
        _cr.c(BoxC.N, {
          key: -10,
//          boxStlz: _abtz.boxStlz,
          boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
          boxClds: [
            _cr.c(TextC.N, {
              key: -10,
              text: pz.text,
              textStlz: a('tc/lt9'),
              textPtyz: a('tn/10'),
              boxStlz: a('dw/f fd/csc fw/w'),
            }),
            _cr.c(BoxC.N, {
              key: -20,
              boxStlz: a('dw/f fd/rac mt/1'),
              boxClds: _ls.map((_dz: _ht.dz, _idx: _ht.n) => {
                return (
                  _cr.c(BtnC.N, {
                    key: _idx,
                    abtz: {
                      type: 'ctd',
                      sc: 'lt5',
                      tc: 'lt1',
                      dh: 3.5,
                      dw: 15,
                      br: 2,
                      ... pz.abtz?.btnNextz,
                    },
                    lblCz: {
//                      text: _dz.pfx,
                      text: _dz.text,
                    },
                    frmCz: {
                      pslStlz: a(`dw/n`),
                      pslPtyz: {
                        onPrs: () => {
                          _sMdlz.set({
                            bShow: false,
                          });
                          if (pz.onPrs) pz.onPrs(_dz.key);
                        },
                      },
                    }
                  })
                )
              })
            })
          ],
        })
      ]
    })
  }

  return {
    show: _show
  }
};
